export function getEnvironment(): 'development' | 'staging' | 'production' {
  const host = window.location.host;

  if (host.includes('dev')) {
    return 'development';
  }

  if (host.includes('stg')) {
    return 'staging';
  }

  return 'production';
}
